/**
 * listing operations
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {
    updateSearchAction,
    fetchObjectQueryAction,
    deleteObjectAction,
    undeleteObjectAction
} from "../redux/listing/actions";
import {
    setFilterAction,
    setSubFiltersAction
} from "../redux/menu/actions";
import {OBJECT_LIST_PAGE} from "../redux/view/consts";
import {
    REST_CALL_DELETE_OBJECT,
    REST_CALL_UNDELETE_OBJECT,
    REST_CALL_FILTER_GROUPS,
    REST_SERVER_BASE_URL
} from "../config";
import {showError} from "./message";
import {openPageAction} from "../redux/view/actions";
import {pushStateAction} from "../redux/navigation/actions";
import {fetchJSONActivity} from "./communication";
import {fetchObjectQuery, excludeDeleted} from "./objects";


export function updateSearchInput(text) {

    return dispatch => {
        dispatch(updateSearchAction(text));
    };
}

export function showInitialFilter() {

    return async (dispatch, getState) => {
        await filterObjects(getState().menu.initialFilter)(dispatch, getState);
    }
}

export function showCurrentFilter() {

    return async (dispatch, getState) => {
        await filterObjects(getState().menu.currentFilter)(dispatch, getState);
    }
}

function getFilterQuery(filter) {
    const types = filter.fields.types;
    const query = filter.fields.query;
    const subQuery = filter.fields.subQuery || {};
    if (query) {
        return {...query, ...subQuery};
    }
    else if (types) {
        if (types.length === 1) {
            return {"type": types[0], ...subQuery}
        }
        else {
            return {"type": {"$in": types}, ...subQuery}
        }
    }
    else {
        return undefined;
    }
}

function createSubFilters(parentFilter, groupField, groups) {
    return groups.sort().map(group => {
        return {
            id: parentFilter.id + "." + group,
            parent: parentFilter,
            fields: {
                name: group,
                iconurl: parentFilter.fields.iconurl,
                types: parentFilter.fields.types,
                orderBy: parentFilter.fields.orderBy,
                subQuery: {["fields." + groupField]: group}
            }
        }
    });
}

export function filterObjects(filter) {

    return async (dispatch, getState) => {

        if (!filter) return; // TODO: show error page?

        // push new state
        dispatch(pushStateAction("object list"));

        // record filter
        dispatch(setFilterAction(filter));

        // find groups for this filter
        if (filter.fields.groupBy) {
            try {
                const groups = await fetchFilterGroups(dispatch, getState, filter.id);
                dispatch(setSubFiltersAction(filter.id, createSubFilters(filter, filter.fields.groupBy, groups)));
            }
            catch (error) {
                showError(error)(dispatch);
            }
        }

        // generate search filter
        if (await executeSearch(dispatch, getState, excludeDeleted(getFilterQuery(filter)), filter.fields.orderBy)) {
            dispatch(openPageAction(OBJECT_LIST_PAGE));
        }
        else {
            // TODO: show error page
        }
    }
};

export function searchTag(tag) {

    return async (dispatch, getState) => {

        // push new state
        dispatch(pushStateAction("search results"));

        // record on-the-fly filter
        const query = {tags: tag};
        dispatch(setFilterAction({fields: {name: "search tags", icon: undefined, query: query, orderBy: undefined}}));

        // execute search
        if (await executeSearch(dispatch, getState, excludeDeleted(query))) {
            dispatch(openPageAction(OBJECT_LIST_PAGE));
        }
        else {
            // TODO: show error page
        }
    }
}

export function searchPhrase(phrase) {

    return async (dispatch, getState) => {

        // push new state
        dispatch(pushStateAction("search results"));

        // clear search input
        // TODO: really?
        dispatch(updateSearchAction(""));

        // record on-the-fly filter
        const query = phrase ? {"$text": {"$search": phrase}} : getState().menu.initialFilter.query;
        dispatch(setFilterAction({fields: {name: "search text", icon: undefined, query: query, orderBy: undefined}}));

        // execute search
        if (await executeSearch(dispatch, getState, excludeDeleted(query))) {
            dispatch(openPageAction(OBJECT_LIST_PAGE));
        }
        else {
            // TODO: show error page
        }
    }
};

async function executeSearch(dispatch, getState, query, orderBy = undefined)
{
    try {
        const response = await fetchObjectQuery(dispatch, getState, query, orderBy);
        console.log("search result:", response);
        dispatch(fetchObjectQueryAction(response.items, response.accesslevels, response.refcounts));
        return true;
    }
    catch (error) {
        showError(error)(dispatch);
        return false;
    }
}

export function deleteObject(id) {

    return async (dispatch, getState) => {

        try {
            const { authorization } = getState();

            await fetchJSONActivity(dispatch, "deleting object",
                REST_SERVER_BASE_URL + REST_CALL_DELETE_OBJECT.path.replace("<id>", id), {
                    method: REST_CALL_DELETE_OBJECT.method,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + authorization.accessToken
                    }
                }
            );

            dispatch(deleteObjectAction(id));
        }
        catch (error) {
            showError(error)(dispatch);
        }
    }
}

export function undeleteObject(id) {

    return async (dispatch, getState) => {

        try {
            const { authorization } = getState();

            await fetchJSONActivity(dispatch, "undeleting object",
                REST_SERVER_BASE_URL + REST_CALL_UNDELETE_OBJECT.path.replace("<id>", id), {
                    method: REST_CALL_UNDELETE_OBJECT.method,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + authorization.accessToken
                    }
                }
            );

            dispatch(undeleteObjectAction(id));
        }
        catch (error) {
            showError(error)(dispatch);
        }
    }
}

async function fetchFilterGroups(dispatch, getState, filterId)
{
    // do server communication
    const { authorization } = getState();
    return await fetchJSONActivity(dispatch, "fetching filter groups",
        REST_SERVER_BASE_URL + REST_CALL_FILTER_GROUPS.path.replace("<id>", filterId), {
            method: REST_CALL_FILTER_GROUPS.method,
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authorization.accessToken
            }
        }
    );
}
